import audio from '@/scripts/audio';
import eventHub from '@/scripts/eventHub';
import gsap from 'gsap';
import {
  AnimatedSprite,
  Loader,
  Point,
  Texture,
  TilingSprite,
} from 'pixi.js';
import vars from '../vars';

class PowerUp {
  constructor(parent, renderer, stage) {
    this.parent = parent;
    this.tileDirection = true;

    const skyTexture = new Texture(Loader.shared.resources['textures/SKY'].texture);
    this.sky = new TilingSprite(skyTexture, vars.layout.FRAME_WIDTH, skyTexture.orig.height);
    this.sky.tilePosition.y = -vars.layout.FRAME_HEIGHT;
    this.sky.renderable = false;

    const textures = [
      ...Object.values(Loader.shared.resources['sprites/POWERUP_1'].spritesheet.textures),
      ...Object.values(Loader.shared.resources['sprites/POWERUP_2'].spritesheet.textures),
    ];
    this.sprite = new AnimatedSprite(textures);
    textures.forEach((t) => { renderer.plugins.prepare.upload(t); });
    this.sprite.loop = false;
    this.sprite.animationSpeed = 0.5;
    this.sprite.onComplete = () => {
      this.sprite.renderable = false;
      audio.play('weeee');
    };

    const linesTextures = [
      ...Object.values(Loader.shared.resources['sprites/POWERUP_LINES_1'].spritesheet.textures),
      ...Object.values(Loader.shared.resources['sprites/POWERUP_LINES_2'].spritesheet.textures),
    ];
    this.lines = new AnimatedSprite(linesTextures);
    linesTextures.forEach((t) => { renderer.plugins.prepare.upload(t); });
    this.lines.loop = true;
    this.lines.animationSpeed = 0.4;
    this.lines.play();
    this.lines.renderable = false;

    this.shakeTimeline = gsap.timeline({ paused: true, yoyo: true, repeat: -1 });
    const amount = 5;
    this.shakeTimeline.to(stage.position, { x: `+=${amount}`, duration: 0.05, ease: 'linear.none' });
    this.shakeTimeline.to(stage.position, { x: `-=${amount}`, duration: 0.05, ease: 'linear.none' });
    this.shakeTimeline.to(stage.position, { x: `+=${amount}`, duration: 0.05, ease: 'linear.none' });
    this.shakeTimeline.to(stage.position, { x: `-=${amount}`, duration: 0.05, ease: 'linear.none' });

    this.resize();

    this.parent.addChild(this.lines);
    this.parent.addChild(this.sky);
    this.parent.addChild(this.sprite);

    this.changeLevelHandler = () => {
      gsap.to(this.sky.tilePosition, {
        y: `${this.tileDirection ? '+' : '-'}=${vars.layout.FRAME_HEIGHT / 6}`,
        ease: 'power2.inOut',
        duration: 5,
      }).then(() => {
        if (
          this.sky.tilePosition.y >= -vars.layout.FRAME_HEIGHT / 6
          || this.sky.tilePosition.y <= -vars.layout.FRAME_HEIGHT
        ) {
          this.tileDirection = !this.tileDirection;
        }
      });
    };
    eventHub.$on('levelchange', this.changeLevelHandler);

    eventHub.$on('power', () => {
      this.sprite.renderable = true;
      this.sprite.gotoAndPlay(0);
      this.lines.renderable = true;
      this.shakeTimeline.play();
      audio.play('powerup');
      this.sky.renderable = true;
      gsap.fromTo(this.sky, { alpha: 0 }, { alpha: 1, duration: 0.2 });
      gsap.fromTo(this.sky, { alpha: 1 }, { alpha: 0, duration: 0.2, delay: 2.2 });
    });

    eventHub.$on('powerend', () => {
      this.lines.renderable = false;
      gsap.set(stage, { x: 0 });
      this.shakeTimeline.pause();
    });
  }

  resize() {
    this.sprite.anchor = new Point(0.5, 0.5);
    this.sprite.position.x = vars.layout.FRAME_WIDTH / 2;
    this.sprite.position.y = vars.layout.FRAME_HEIGHT / 2;
    this.lines.anchor = new Point(0.5, 0.5);
    this.lines.position.x = vars.layout.FRAME_WIDTH / 2;
    this.lines.position.y = vars.layout.FRAME_HEIGHT / 2;
  }
}

export default PowerUp;
